import classNames from 'classnames'
import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { toNumber } from 'lodash'

export const Content = ({ dataGrid, dataGridColumn, children }) => {
  const location = useLocation()
  const { id } = useParams()

  const isCopilotView =
    location.pathname.startsWith('/qa-copilot') ||
    location.pathname.startsWith('/coaching/scorecards')
  const isCopilotCreateView =
    location.pathname.startsWith('/qa-copilot/create') ||
    location.pathname.startsWith('/coaching/scorecards/create')

  const isQAEdit = isCopilotView && id && !Number.isNaN(toNumber(id))
  const addWithStickyNavigation = isCopilotCreateView || isQAEdit
  const { sidebarCollapsed } = useSelector((state) => state.ui)

  return (
    <main
      className={classNames('balto-content', {
        collapse: sidebarCollapsed,
      })}
    >
      <div
        className={classNames('balto-content__inner', {
          'with-sticky-navigation': addWithStickyNavigation,
          'with-data-grid': dataGrid,
          // opts flat grid pages (grid is a direct child of this div) into the
          // viewport flex column in theme.scss; gating on .data-grid presence
          // via :has is not an option because the grid unmounts while loading
          'with-data-grid-column': dataGridColumn,
        })}
      >
        {children}
      </div>
    </main>
  )
}
